import { FormSchemaEntry } from '@gik/ui/Form';
import i18n from '@gik/i18n';
import { translationKeys } from '@gik/core/form/i18n/en';

export const recipientFullNameRegex = /\//i;
export const recipientFullNameField = (customProps?: FormSchemaEntry): FormSchemaEntry => ({
  name: 'recipientFullName',
  type: 'text',
  required: true,
  minLength: 2,
  maxLength: 255,
  placeholder: i18n.t(translationKeys.recipientFullNamePlaceholder),
  props: { autoComplete: 'full-name' },
  customValidation: [
    {
      // returns false when field is valid
      validate: (value: string) => recipientFullNameRegex.test(value),
      message: i18n.t(translationKeys.fieldHasInvalidCharacters),
    },
  ],
  ...customProps,
});
